import { MS_PER_MINUTE } from './units.js';

const MINUTES_PER_STEP = 10;
const TEN_MINUTES_MS = MINUTES_PER_STEP * MS_PER_MINUTE;
const COMPACT_LENGTH = 12;
const COMPACT_PATTERN = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})$/;
const MONTH_OFFSET = 1;

const pad2 = (value: number): string => String(value).padStart(2, '0');

export const RADAR_STEP_MS = TEN_MINUTES_MS;

export const floorToRadarStep = (date: Date): Date => new Date(
  Math.floor(date.getTime() / TEN_MINUTES_MS) * TEN_MINUTES_MS,
);

export const isRadarStepAligned = (date: Date): boolean => date.getTime() % TEN_MINUTES_MS === 0;

export const addRadarSteps = (date: Date, steps: number): Date => new Date(date.getTime() + steps * TEN_MINUTES_MS);

export const toCompact = (date: Date): string => [
  String(date.getUTCFullYear()),
  pad2(date.getUTCMonth() + MONTH_OFFSET),
  pad2(date.getUTCDate()),
  pad2(date.getUTCHours()),
  pad2(date.getUTCMinutes()),
].join('');

export const fromCompact = (compact: string): Date | null => {
  if (compact.length !== COMPACT_LENGTH) {
    return null;
  }
  const match = COMPACT_PATTERN.exec(compact);
  if (!match) {
    return null;
  }
  const [ , year, month, day, hour, minute ] = match;
  const date = new Date(
    Date.UTC(Number(year), Number(month) - MONTH_OFFSET, Number(day), Number(hour), Number(minute)),
  );
  return toCompact(date) === compact ? date : null;
};

export const radarStepsBetween = (from: Date, to: Date): Date[] => {
  const start = floorToRadarStep(from).getTime();
  const end = floorToRadarStep(to).getTime();
  const result: Date[] = [];
  for (let time = start; time <= end; time += TEN_MINUTES_MS) {
    result.push(new Date(time));
  }
  return result;
};

export const formatLocal = (date: Date, timeZone: string, locale = 'es-ES'): string => new Intl.DateTimeFormat(locale, {
  timeZone,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
}).format(date);
